import Layout from "../components/layout/Layout";
import AllSpotsPage from "../components/page/AllSpots";

const AllSpotPage = () => {
  return (
    <Layout>
      <AllSpotsPage />
    </Layout>
  );
};
export default AllSpotPage;
